import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import { getBarberUserId, isBarberUser } from '../../../auth/selectors';
import { addBarber } from '../../order/actions';
import List from '../components/List';
import * as barberSelectors from '../../../main/barbers/selector';
import { setActiveBarber } from '../../sale/actions';


const ListContainer = compose(
  connect(
    state => ({
      items: barberSelectors.getAll(state),
      isBarber: isBarberUser(state),
      barberUserId: getBarberUserId(state),
    }),
    { addBarber, setActiveBarber }
  ),
  withHandlers({
    selectBarber: props => (id) => {
      props.addBarber(id);
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.isBarber) {
        this.props.selectBarber(this.props.barberUserId);
      }
    },
  })
)(List);

export default ListContainer;
